import { ReactNode } from "react";
import { Colors } from "shared/styles";
import styled, { CSSProp } from "styled-components";

type Props = {
  radioGroupName: string;
  label: ReactNode;
  value: string;
  hint?: string;
  onChange: (value: string) => void;
  checked: boolean;
  className?: string;
  inputStyle?: CSSProp;
  labelStyle?: CSSProp;
};

const Radio = ({
  radioGroupName,
  label,
  value,
  hint,
  onChange,
  checked,
  className,
  inputStyle,
  labelStyle,
}: Props) => {
  return (
    <div key={value} tw="flex items-center my-4" className={className}>
      <>
        <Input
          type="radio"
          name={radioGroupName}
          id={value}
          onClick={() => onChange(value)}
          value={value}
          checked={checked}
          css={inputStyle}
        />
        <Label htmlFor={value} css={labelStyle}>
          {label}
          {hint && <Hint>{hint}</Hint>}
        </Label>
      </>
    </div>
  );
};

const Input = styled.input`
  width: 28px;
  height: 28px;
  border-radius: 14px;
  background: ${Colors.blue["01"]};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  cursor: pointer;

  &:checked {
    &:before {
      content: "";
      display: block;
      width: 14px;
      height: 14px;
      border-radius: 7px;
      background: ${Colors.gradient["01"]};
    }
  }
`;

const Label = styled.label`
  font-weight: 600;
  font-size: 12px;
  color: ${Colors.black["01"]};
  display: flex;
  flex-direction: column;
`;

const Hint = styled.span`
  font-weight: 300;
  font-size: 8px;
  color: ${Colors.black["01"]};
  margin-top: 4px;
`;

export default Radio;
